import { api } from "./api";

export type EventItem = {
  id: string;
  title: string;
  slug: string;
  shortDescription: string | null;
  description: string | null;
  imageUrl: string | null;
  startDate: string;          // "2026-07-18"
  endDate: string | null;
  startTime: string | null;   // "07:00:00"
  location: string | null;
  city: string | null;
  externalUrl: string | null;
  linkedTourSlug: string | null;
  isFeatured: boolean;
  isPublished: boolean;
  displayOrder: number;
};

export type WriteEventInput = {
  title: string;
  slug?: string | null;
  shortDescription?: string | null;
  description?: string | null;
  imageUrl?: string | null;
  startDate: string;
  endDate?: string | null;
  startTime?: string | null;
  location?: string | null;
  city?: string | null;
  externalUrl?: string | null;
  linkedTourSlug?: string | null;
  isFeatured: boolean;
  isPublished: boolean;
  displayOrder: number;
};

// ---- Public ----
export function listEvents(city?: string, take?: number): Promise<EventItem[]> {
  const q = new URLSearchParams();
  if (city) q.set("city", city);
  if (take) q.set("take", String(take));
  const qs = q.toString();
  return api<EventItem[]>(`/events${qs ? `?${qs}` : ""}`, { auth: false });
}

export function listFeaturedEvents(take = 4): Promise<EventItem[]> {
  return api<EventItem[]>(`/events/featured?take=${take}`, { auth: false });
}

export function getEvent(slug: string): Promise<EventItem> {
  return api<EventItem>(`/events/${slug}`, { auth: false });
}

// ---- Admin ----
export function listAllEvents(): Promise<EventItem[]> {
  return api<EventItem[]>("/admin/events");
}
export function getEventAdmin(id: string): Promise<EventItem> {
  return api<EventItem>(`/admin/events/${id}`);
}
export function createEvent(input: WriteEventInput): Promise<EventItem> {
  return api<EventItem>("/admin/events", { method: "POST", body: input });
}
export function updateEvent(id: string, input: WriteEventInput): Promise<EventItem> {
  return api<EventItem>(`/admin/events/${id}`, { method: "PUT", body: input });
}
export function deleteEvent(id: string): Promise<void> {
  return api<void>(`/admin/events/${id}`, { method: "DELETE" });
}

/** Human date range, Spanish. */
export function formatEventDate(ev: Pick<EventItem, "startDate" | "endDate">, locale = "es-MX"): string {
  const fmt = new Intl.DateTimeFormat(locale, { day: "numeric", month: "long", year: "numeric" });
  const start = fmt.format(new Date(ev.startDate + "T12:00:00"));
  if (!ev.endDate || ev.endDate === ev.startDate) return start;
  return `${fmt.format(new Date(ev.startDate + "T12:00:00"))} – ${fmt.format(new Date(ev.endDate + "T12:00:00"))}`;
}
